export enum DatasheetTabNameManagementMode {
  add = "add",
  insert = "insert",
  rename = "rename",
  paste = "paste",
};

export type DatasheetTabNameManagementSubmitParams = {
  tabName: string;
};

export type DatasheetTabNameManagementProps = {
  onClose: () => void;
  onSubmit: (params: DatasheetTabNameManagementSubmitParams) => void;
  mode: DatasheetTabNameManagementMode;
  /** When in rename mode, pre-fill the input with this name. */
  initialTabName?: string;
};

export type DatasheetTabNameManagementConfig = {
  title: string;
};
